import _ from '../../core/utils'

const EVENTS_CONFIG = {
    section: _.select( '.section--events-content' ),
    time: {
        toggle: _.select( '.section--events-content .events__time-toggle' ),
        past: _.selectAll( '.section--events-content .past' ),
        upcoming: _.selectAll( '.section--events-content .upcoming' )
    },
    grid: {
        wrap: _.select( '.section--events-content .fl__card-grid' ),
        items: _.selectAll( '.section--events-content .fl__card--event' ),
        calendar: _.select( '.fl__calendar' ),
        clear: _.select( '.fl__calendar--clear' )
    }
}

export default EVENTS_CONFIG